export const MIN_WIDTH = 75;
export const DIVIDER_WIDTH = 34;
//# sourceMappingURL=index.js.map